// Basic
import PropTypes from 'prop-types';
// Libs
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { QRCodeSVG } from 'qrcode.react';
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Components
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from '@/common-utils/components/ui/inputOtp';
import { ModalBody } from '@/common-utils/components/ui/modal';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Images
import microsoftLogo from 'url:../../../../../../../../../resource/images/microsoft_logo.png';
import androidLogo from 'url:../../../../../../../../../resource/images/android_logo.png';
import appleLogo from 'url:../../../../../../../../../resource/images/apple_logo.png';
// Css
import './BodyInitMFA.scss';
// Lang
import { nsSession } from '@/app/i18n/namespaces';

/**
 * @param {boolean} isLoadingQrcodUri
 * @param {boolean} isLoadingInitMfa
 * @param {Object} qrcodeUri
 * @param {OBject} appCodeSetter
 * @param {number} leftAttempts
 * @returns {JSX} BodyInitMFA
 */
function BodyInitMFA({ qrcodeUri, isLoadingQrcodUri, isLoadingInitMfa, appCodeSetter, leftAttempts, closeOnError }) {
    // Props destructuring
    const { appCode, setAppCode } = appCodeSetter;

    // Constants
    const logos = [
        {
            src: microsoftLogo,
            link: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=fr&gl=US&pli=1'
        },
        {
            src: androidLogo,
            link: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=fr&gl=US&pli=1'
        },
        {
            src: appleLogo,
            link: 'https://apps.apple.com/fr/app/google-authenticator/id388497605'
        }
    ];

    return (
        <ModalBody>
            {isLoadingQrcodUri &&
                <Spinner className='panel-spinner' />
            }
            {!isLoadingQrcodUri && qrcodeUri &&
                (
                    <div>
                        <div className='mfa-container'>
                            <Entity namespace={nsSession} entity='mfa.application' />
                            <div className='mfa-images'>
                                {logos.map((logo) =>
                                    <div key={logo.src}>
                                        <a href={logo.link} target='_blank' rel='noopener noreferrer' className='img-app-mfa'>
                                            <img alt='' className='img-app-mfa' src={logo.src} />
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='mfa-container'>
                            <Entity namespace={nsSession} entity='mfa.qrcode' />
                            <div className='mfa-images'>
                                {qrcodeUri && qrcodeUri.MfaUri ?
                                    <QRCodeSVG value={qrcodeUri.MfaUri} id='svg-qrcode' renderas='svg' />
                                    :
                                    <Entity namespace={nsSession} entity='mfa.init_error' className={cn('text-danger')} />
                                }
                            </div>
                        </div>
                        <Entity namespace={nsSession} entity='mfa.code_validation' />
                        <InputOTP
                            containerClassName={cn('justify-center mt-6 mb-6')}
                            maxLength={6}
                            pattern={REGEXP_ONLY_DIGITS}
                            value={appCode}
                            onChange={(val) => setAppCode(val)}
                        >
                            <InputOTPGroup>
                                {[0, 1, 2].map((index) => <InputOTPSlot key={index} index={index} />)}
                            </InputOTPGroup>
                            <InputOTPSeparator />
                            <InputOTPGroup>
                                {[3, 4, 5].map((index) => <InputOTPSlot key={index} index={index} />)}
                            </InputOTPGroup>
                        </InputOTP>
                        {[1, 2].includes(leftAttempts) && !isLoadingInitMfa
                            && <Entity
                                namespace={nsSession}
                                entity={leftAttempts > 1 ?
                                    'mfa.attempts_info_init_plural'
                                    : 'mfa.attempts_info_init_singular'}
                                data={{ attempts: leftAttempts }}
                                className='mfa-attempts-information' />}
                    </div>
                )
            }
            {!isLoadingQrcodUri && !qrcodeUri &&
                (
                    <>
                        {closeOnError()}
                    </>
                )
            }
        </ModalBody>
    );
}

BodyInitMFA.propTypes = {
    qrcodeUri: PropTypes.object,
    isLoadingQrcodUri: PropTypes.bool,
    isLoadingInitMfa: PropTypes.bool,
    appCodeSetter: PropTypes.object,
    leftAttempts: PropTypes.number,
    closeOnError: PropTypes.func
};

export default BodyInitMFA;